import React, { Component } from "react";
import { Link } from "react-router-dom";
import textosJSON from "./textosMenu.json";

const SubmenuGrupo = ({ mobile, ocultarMenu, idioma }) => {
  const texto = (nombre) => {
    return (textosJSON[nombre]?.[idioma])??(textosJSON[nombre]?.["es"])??""
  }
  return (
    <div 
    style={mobile?
    {
      position: "relative",
      left: "5%",
      top: 25,
      width: "100%",
      backgroundColor: "#242e37",
    }:
    {
      position: "absolute",
      marginTop: -32,
      width: 160,
      height: 214,
      background: "rgba(217, 217, 217, 0.05)",
      paddingLeft: 12,
      paddingTop: 44,
      paddingBottom: 12,
      paddingRight: 12,
      marginLeft: -12,
      borderRadius: 5,
    }}>
      <Link className="subItemNavBar" to={"/" + idioma + "/home#aboutUs"} onClick={ocultarMenu}>{texto("quienesSomos")}</Link>
      <Link className="subItemNavBar" to={"/" + idioma + "/home#international"} onClick={ocultarMenu}>{texto("internacional")}</Link>
      <Link className="subItemNavBar" to={"/" + idioma + "/home#brands"} onClick={ocultarMenu}>{texto("nuestrasMarcas")}</Link>
      <Link className="subItemNavBar" to={"/" + idioma + "/home#partners"} onClick={ocultarMenu}>{texto("partners")}</Link>
    </div>
  );
};

export default SubmenuGrupo;
